import { DASHBOARD_SETTING_CATEGORIES } from '../data/settingsDashboardCatalog';

export type DashboardPrefsMap = Record<string, string | boolean>;

export function dashboardPrefsStorageKey(userId: string | undefined): string {
  return `district88_dashboard_prefs:${userId || 'guest'}`;
}

export function buildDefaultDashboardPrefsFromCatalog(): DashboardPrefsMap {
  const o: DashboardPrefsMap = {};
  for (const cat of DASHBOARD_SETTING_CATEGORIES) {
    for (const item of cat.items) {
      if (item.kind === 'toggle') {
        o[item.id] = item.future ? false : true;
      } else if (item.kind === 'select' && item.options?.length) {
        o[item.id] = item.options[0].value;
      }
    }
  }
  o.notif_promotions = false;
  o.notif_sms = false;
  o.notif_push = false;
  o.appearance_reduce_motion = false;
  o.appearance_high_contrast = false;
  o.sell_listing_visibility = true;
  o.sell_returns_policy = true;
  o.sell_accept_offers = true;
  o.pay_fee_breakdown = true;
  o.soc_mute_keywords = false;
  o.soc_mute_terms_csv = '';
  return o;
}

const TOGGLE_PREF_IDS = new Set(
  DASHBOARD_SETTING_CATEGORIES.flatMap((c) => c.items.filter((i) => i.kind === 'toggle').map((i) => i.id))
);

function coerceToggle(v: unknown): boolean {
  if (v === true || v === 'true' || v === 1 || v === '1') return true;
  if (v === false || v === 'false' || v === 0 || v === '0' || v === '' || v === null || v === undefined) return false;
  return Boolean(v);
}

/** Merge remote or local JSON into defaults; toggles are coerced so string "false" from JSON does not stay truthy. */
export function mergeDashboardPrefsPatch(base: DashboardPrefsMap, patch: Record<string, unknown> | null): DashboardPrefsMap {
  if (!patch) return { ...base };
  const next = { ...base };
  for (const k of Object.keys(patch)) {
    const v = patch[k];
    if (TOGGLE_PREF_IDS.has(k)) {
      next[k] = coerceToggle(v);
      continue;
    }
    if (typeof v === 'boolean' || typeof v === 'string') next[k] = v;
  }
  return next;
}

/** Synchronous read for guests or before remote merge (Market, layout). */
export function readDashboardPrefsFromLocalStorage(userId: string | undefined): DashboardPrefsMap {
  const base = buildDefaultDashboardPrefsFromCatalog();
  try {
    const raw = localStorage.getItem(dashboardPrefsStorageKey(userId));
    if (raw) return mergeDashboardPrefsPatch(base, JSON.parse(raw) as Record<string, unknown>);
  } catch {
    /* */
  }
  return base;
}

export function broadcastControlCenterPrefs(detail: DashboardPrefsMap): void {
  try {
    window.dispatchEvent(new CustomEvent('d88-control-prefs-changed', { detail }));
  } catch {
    /* */
  }
}
